import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Profile = {
  id: string;
  nome: string;
  email: string;
  tipo_conta: 'cliente' | 'admin' | 'ceo';
  cargo?: string;
  avatar_url?: string;
  created_at: string;
  updated_at: string;
};

export type ProdutoAdquirido = {
  id: string;
  user_id: string;
  produto_id: string;
  produto_nome: string;
  produto_tipo: 'curso' | 'ebook';
  data_compra: string;
  valor_pago: number;
  status: 'ativo' | 'expirado' | 'cancelado';
};

export type PermissoesEquipa = {
  id: string;
  user_id: string;
  pode_ver_financeiro: boolean;
  pode_criar_conteudo: boolean;
  pode_editar_conteudo: boolean;
  requer_aprovacao_ceo: boolean;
  pode_gerir_utilizadores: boolean;
  created_at: string;
  updated_at: string;
};
